import { useBlocker } from "@tanstack/react-router";
import type { ScannedBagInput } from "@pm-barcode/shared";

const alwaysBlock = () => true;

/** Total bags across scan entries — a lot entry carries its entered count as `quantity`. */
export function bagTotal(bags: ScannedBagInput[]): number {
  return bags.reduce((sum, b) => sum + b.quantity, 0);
}

/**
 * Hold every way off a scan screen while it has unsaved scans: the on-screen ← button, the
 * TC58 hardware back button (the Android shell calls WebView.goBack → popstate), any other
 * in-app navigation, and a page reload/close.
 *
 * Returns the router's blocker resolver. While `status === "blocked"` the screen shows its
 * leave confirmation; `proceed()` completes the navigation (scans discarded), `reset()`
 * cancels it and keeps the operator on the screen.
 */
export function useLeaveGuard(active: boolean) {
  return useBlocker({
    shouldBlockFn: alwaysBlock,
    enableBeforeUnload: active,
    disabled: !active,
    withResolver: true,
  });
}
